// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IElectronicFundingDto
 */
export interface IElectronicFundingDto {
    /**
     * 
     * @type {number}
     * @memberof IElectronicFundingDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IElectronicFundingDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IElectronicFundingDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IElectronicFundingDto interface.
 */
export function instanceOfIElectronicFundingDto(value: object): value is IElectronicFundingDto {
    return true;
}

export function IElectronicFundingDtoFromJSON(json: any): IElectronicFundingDto {
    return IElectronicFundingDtoFromJSONTyped(json, false);
}

export function IElectronicFundingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IElectronicFundingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IElectronicFundingDtoToJSON(json: any): IElectronicFundingDto {
    return IElectronicFundingDtoToJSONTyped(json, false);
}

export function IElectronicFundingDtoToJSONTyped(value?: IElectronicFundingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

